module.exports = __webpack_public_path__ + "img/jujialei-7.444a8250.png";